<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", ref="selectize", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", @itemRemoved="optionRemoved", placeholder="Segments")
</template>

<script>
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'
import BaseSelectize from './BaseSelectize'
import Selectize from '../../../Selectize'

export default {
  name: 'SelectizeSegment',
  extends: BaseSelectize,
  components: {Selectize},
  data() {
    return {
      searchableFields: [
        'id',
        'brand',
        'model',
        'plate',
        'parking_lot_id',
        'parking_lot_name',
        'parking_slot'
      ],
    }
  },
  created() {

    KeplerBackofficeSdk.segments.list(1, -1).all((data) => {
      this.options = data.items
    })
  },
  methods: {
    optionTemplate(item, escape) {
      return `<div><div>S${item.id} ${item.name}</div></div>`
    },
    renderTemplate(item, escape) {
      return `<div><div>S${item.id} ${item.name}</div></div>`
    },
    optionsLoader() {

    },
    clearSelected() {
      this.$refs.selectize.clearSelected()
    }
  },
  props: ['selectedValue', 'disabledSlot', 'archived']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeSegment.vue?1fcefb99